import styled from 'styled-components';
import {transparentize} from 'polished';

export const Wrapper = styled.div`
  
`;

export const Content = styled.div`
  margin-top: 15px;
`;

export const Container = styled.div`
  flex-wrap: wrap;
  align-items: flex-start;
  display: flex;
`;

export const Params = styled.div`
  flex-wrap: wrap;
  display: flex;
`;

export const Param = styled.button`
  position: relative;
  margin-right: 6px;
  column-gap: 4px;
  align-content: center;
  grid-auto-flow: column;
  display: inline-grid;
  
  padding: 8px 24px 8px 10px;
  box-sizing: border-box;
  
  border-radius: 5px;
  background-color: ${({theme}) => `
    ${transparentize(.95, theme.variables.color)};
  `};
  
  font-size: 12px;
  line-height: 16px;
  
  &:after {
    content: "";

    position: absolute;
    margin: auto;
    top: 0;
    right: 10px;
    bottom: 0;
    
    background-position: center;
    background-image: url("data:image/svg+xml,%3Csvg width='8' height='8' viewBox='0 0 8 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4.88889 4L8 0.888889L7.11111 0L4 3.11111L0.888889 0L2.11928e-07 0.888889L3.11111 4L0 7.11111L0.888889 8L4 4.88889L7.11111 8L8 7.11111L4.88889 4Z' fill='white'/%3E%3C/svg%3E%0A");
    height: 8px;
    width: 8px;
  }
`;
